import { render } from "./AddPassengerModalView.vue?vue&type=template&id=435236d0&scoped=true"
import script from "./AddPassengerModalView.vue?vue&type=script&lang=js"
export * from "./AddPassengerModalView.vue?vue&type=script&lang=js"

import "./AddPassengerModalView.vue?vue&type=style&index=0&id=435236d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435236d0"]])

export default __exports__